var gsap = require('gsap'),
	common = require('../base/common'),
	emitter = require('../base/emitter');

function SliderText($el){

	var _this = this;
	_this.$el = $el;
	_this.itemClass = '.c-slider-text_item';
	_this.$items = _this.$el.find(_this.itemClass);
	_this.$pagination = _this.$el.find('.c-slider-text_pagination');
	_this.$timer = _this.$el.find('.c-slider-text_timer');
	_this.interval = null;
	_this.intervalTime = 10000; // in ms
	_this.$navigation = _this.$el.find('.c-slider-text_arrows button');

	_this.createPagination();

	_this.$navigation.on('click', function(e){
		e.preventDefault();
		_this.stopTimer();
		if($(this).hasClass('_next'))
			_this.nextSlide();
		else
			_this.prevSlide();
		_this.startTimer();
	})

	_this.$el.on('slidertext:play', function(){
		_this.startTimer();
	})

	_this.$el.on('slidertext:show', function(){
		setTimeout(function(){
			_this.startTimer()
			_this.show();
		},100)
	})

	_this.$el.on('slidertext:hide', function(){
		_this.$el.removeClass('showed');
	})

	_this.$el.on('slidertext:stop', function(){
		_this.stopTimer();
	})

	_this.$el.find('.c-slider-text_item-inner').on('mouseover mouseout', function(e){

		if(e.type == 'mouseover'){
			_this.$el.trigger('slidertext:stop')
		}else{
			_this.$el.trigger('slidertext:play')
		}

	})

	_this.resize();

	common.$window.resize(function(){
		_this.resize();
	})

}

SliderText.prototype.resize = function(){

	var _this = this;
	var maxHeight = 0;
	_this.$items.each(function(){

		var newHeight = $(this).find('.c-slider-text_item-inner').outerHeight();
		if(newHeight > maxHeight){
			maxHeight = newHeight;
		}

	})

	TweenMax.to(_this.$el,0.3, {height: maxHeight});

}

SliderText.prototype.show = function(){

	var _this = this;
	_this.$el.addClass('showed');
	TweenMax.staggerTo(_this.$pagination.find('button'),0.3,{delay:0.5, opacity: 0.5},0.1);


}

SliderText.prototype.nextSlide = function(){

	var _this = this,
		$next = _this.$items.filter('.active').nextAll(_this.itemClass);
	
	if(!$next.length){
		$next = _this.$items.eq(0);
	}
	_this.goToSlide($next.data('index'))

}

SliderText.prototype.prevSlide = function(){

	var _this = this,
		$next = _this.$items.filter('.active').prevAll(_this.itemClass);
	
	if(!$next.length){
		$next = _this.$items.eq(_this.$items.length - 1);
	}
	_this.goToSlide($next.data('index'))

}

SliderText.prototype.goToSlide = function(index){

	var _this = this,
		$active = _this.$items.filter('.active'),
		$activeTitle = $active.find('.c-slider-text_title'),
		$next = _this.$items.eq(index),
		$nextTitle = $next.find('.c-slider-text_title'),
		nextHeight = $next.height(),
		tl = new TimelineMax();

	if($next.hasClass('active')) return;

	TweenMax.set($next,{x:50, opacity: 0});
	TweenMax.set($nextTitle,{opacity: 0});

	tl.add(TweenMax.to($activeTitle,0.3,{opacity: 0}))
	tl.add(TweenMax.to($active,0.3,{x: -50, opacity:0, onComplete: function(){
		$active.removeClass('active').hide();
		$next.show().addClass('active');

	}}))
	// tl.add(TweenMax.to(_this.$el,0.3, {height: nextHeight, onComplete: function(){
	// 	$active.removeClass('active').hide();
	// 	$next.show().addClass('active');
	// }}))
	tl.add(TweenMax.to($next,0.3,{x: 0 ,opacity:1}))
	tl.add(TweenMax.to($nextTitle,0.3,{opacity:1, onComplete: function(){

		_this.$pagination.find('button').removeClass('active');
		_this.$pagination.find('button').eq(index).addClass('active');

	}}))

}

SliderText.prototype.timerAnimation = function(){
		
	var _this = this;
	_this.$timer.find('circle').animate({
		'stroke-dashoffset': 0
	},_this.intervalTime, 'linear', function(){
		_this.$timer.find('circle').removeAttr('style');
		_this.nextSlide();
	})

}

SliderText.prototype.stopTimer = function(){

	var _this = this;
	if(_this.interval){
		clearInterval(_this.interval);
		_this.$timer.find('circle').stop(true,false).removeAttr('style');
	}

}

SliderText.prototype.startTimer = function(){

	var _this = this;
	_this.timerAnimation();
	_this.interval = setInterval(function(){
		_this.timerAnimation();
	},_this.intervalTime);

}

SliderText.prototype.createPagination = function(){

	var _this = this;
	_this.$items.each(function(index){
		var $a = $('<button></button>');
		if(index == 0)
			$a.addClass('active');
		// $a.css('opacity',0)
		$a.on('click', function(e){
			e.preventDefault();
			_this.stopTimer();
			_this.goToSlide(index);
			_this.startTimer();
		})
		_this.$pagination.append($a);
	})

}

module.exports = SliderText;


/** WEBPACK FOOTER **
 ** ./components/slider-text.js
 **/